import App from '@/models/App'

export default class OrderingOrdererApprovalSetting extends App {
    static get entity() {
        return 'OrderingOrdererApprovalSettings'
    }

    static all() {
        return this.query().with('user').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            approvalName: this.attr(''),
            approvalType: this.attr(''),
            approvalCount: this.attr(''),
            sort: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/approval/settings`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/approval/settings`,
                    App.post(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingApprovalSettingId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/approval/settings/${orderingApprovalSettingId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingApprovalSettingId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/approval/settings/${orderingApprovalSettingId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingApprovalSettingId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
